import angular from "angular";

import "../../../services/mailchimp";

angular.module("folkeuni").component("checkoutNewsletter", {
  bindings: {
    cart: "=",
    siteId: "=",
  },
  controller: function (Mailchimp, $scope, $timeout) {
    var $ctrl = this;
    $ctrl.loading = false;
    $ctrl.hasNewsletterToday = false;
    $ctrl.newsletterSignup = true;
    $ctrl.newsletterAdjust = false;

    var emailDebounceTimeout;
    var lastEmail = null;
    var lastConfirmEmail = null;

    function fetchNewsletterData(email) {
      email = email.toLowerCase().trim();
      if (!email) return;
      Mailchimp.getSubscriber($ctrl.siteId, email).then(function (user) {
        $ctrl.hasNewsletterToday = user.statusCode === undefined;
      });
      Mailchimp.categoriesGetBySiteId($ctrl.siteId, email).then(function (
        categories
      ) {
        $ctrl.cart.newsletter = categories;
      });
    }

    $ctrl.$onInit = function () {
      var email = $ctrl.cart.checkout?.customer?.email;
      var confirmEmail = $ctrl.cart.checkout?.customer?.confirmEmail;
      if (email && confirmEmail && email === confirmEmail) {
        fetchNewsletterData(email);
      }

      $scope.$watchGroup(
        [
          function () {
            return $ctrl.cart.checkout?.customer?.email;
          },
          function () {
            return $ctrl.cart.checkout?.customer?.confirmEmail;
          },
        ],
        function (newVals, oldVals) {
          var email = newVals[0];
          var confirmEmail = newVals[1];
          if (email === lastEmail && confirmEmail === lastConfirmEmail) return;
          lastEmail = email;
          lastConfirmEmail = confirmEmail;
          if (emailDebounceTimeout) $timeout.cancel(emailDebounceTimeout);
          if (email && confirmEmail && email === confirmEmail) {
            emailDebounceTimeout = $timeout(function () {
              fetchNewsletterData(email);
            }, 600);
          }
        }
      );
    };
  },
  templateUrl:
    "/shop-dist/templates/checkout-newsletter.html?c=" + window.cacheBurst,
  transclude: true,
});
